//Importación de librerias
//---------------SICPE---------------
//Catalogos


//Creamos y asignamos los datos necesarios de SICPE
const sicpe = [
  
]

//Exportamos los datos de SICPE
export default sicpe;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/sicpe.js
// module id = null
// module chunks = 